module.exports = {"130281001":"华明路街道","130281002":"文化路街道","130281100":"遵化镇","130281101":"堡子店镇","130281102":"马兰峪镇","130281103":"平安城镇","130281104":"东新庄镇","130281105":"新店子镇","130281106":"党峪镇","130281107":"地北头镇","130281108":"东旧寨镇","130281109":"铁厂镇","130281110":"苏家洼镇","130281111":"建明镇","130281112":"石门镇","130281113":"崔家庄镇","130281200":"西留村乡","130281202":"兴旺寨乡","130281203":"西下营满族乡","130281204":"汤泉满族乡","130281205":"东陵满族乡","130281206":"刘备寨乡","130281207":"团瓢庄乡","130281208":"娘娘庄乡","130281209":"西三里乡","130281210":"侯家寨乡","130281211":"小厂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130281.json
// module id = 182
// module chunks = 0